export const workProcess = [
  {
    name: 'Understand',
    description:
      'We meet with you to understand your goals, site conditions, budget, and timeline.',
  },
  {
    name: 'Plan',
    description:
      'We develop a practical scope, programme, and construction strategy that suits your project and complies with local regulations.',
  },
  {
    name: 'Build',
    description:
      'Our team manages all trades and site activity — safely, efficiently, and to a high standard.',
  },
  {
    name: 'Deliver',
    description:
      'We complete the project on time, to specification, and ready for use — with full documentation and support.',
  },
];
